<div
    class="flex flex-col w-full h-full bg-p-content-background bp908:rounded-2xl p-4 pb-0 pt-2 bp908:pb-4">
    <fm-calendar class="h-full" />
</div>
